<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="500px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    append-to-body
    v-el-dialog-drag
  >
    <el-form
      ref="v_formData"
      :model="v_formData"
      size="small"
      label-position="rigth"
    >
      <el-row :gutter="10">
        <el-col :span="24" class="mb-2 mt-2">
          <el-radio-group v-model="v_formData.extendParameterType" size="small">
            <el-radio-button label="DEFAULT">{{
              $l('INDEX.form_DEFAULT') || '不指定'
            }}</el-radio-button>
            <el-radio-button label="VM">{{
              $l('INDEX.form_VM') || '指定体积'
            }}</el-radio-button>
            <el-radio-button label="LWH">{{
              $l('INDEX.form_LWH') || '放大长宽高'
            }}</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="!typeFlag">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_totalBookingVolume') || '订舱总体积(m³)'"
            prop="containerBookingVolume"
          >
            <el-input-number
              v-model="v_formData.containerBookingVolume"
              style="width:100%"
              :min="0"
              :precision="3"
              :step="0.01"
              controls-position="right"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="typeFlag">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_bookingBoxLength_cm') || '订舱箱长(m)'"
            prop="extendParameterLength"
          >
            <el-input-number
              v-model="v_formData.extendParameterLength"
              style="width:100%"
              :min="0"
              :precision="2"
              :step="0.01"
              controls-position="right"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_bookingBoxWidth_cm') || '订舱箱宽(m)'"
          >
            <el-input-number
              v-model="v_formData.extendParameterWidth"
              style="width:100%"
              :min="0"
              :precision="2"
              :step="0.01"
              controls-position="right"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_bookingBoxHeight_cm') || '订舱箱高(m)'"
            prop="extendParameterHeight"
          >
            <el-input-number
              v-model="v_formData.extendParameterHeight"
              style="width:100%"
              :min="0"
              :precision="2"
              :step="0.01"
              controls-position="right"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    formData: { type: Object, default: () => {} },
  },
  watch: {
    formData: {
      handler(val) {
        if (val) this.v_formData = JSON.parse(JSON.stringify(val))
      },
      immediate: true,
    },
  },
  computed: {
    typeFlag() {
      return this.v_formData.extendParameterType === 'VM' ? false : true
    },
  },
  data() {
    return {
      v_formData: {},
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    confirm() {
      this.$emit('update:formData', this.v_formData)
      this.$emit('change', this.v_formData)
      this.close()
    },
  },
}
</script>
